export enum ESessionFormType {
  FIND_SPECIALIST = 'FIND_SPECIALIST',
  INTERVIEW = 'INTERVIEW',
}